export default __webpack_public_path__ + "static/media/579.46028400.png";